// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"fc405725","259":"cb39ec1b","261":"4ba2783f","440":"8d169c77","453":"64a045f2","567":"2fed0964","609":"19792893","793":"642329b3","849":"c92b182d","918":"98141222","982":"6fd79ec8"}[chunkId] + ".chunk.js";
};